export { default as formatDate } from './dates/format-date';
export { default as parseDate } from './dates/parse-date';
export { default as splitDateFormat } from './dates/split-date-format';

//# sourceMappingURL=dates.js.map



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@telerik/kendo-intl/dist/es/dates.js
// module id = ../../../../@telerik/kendo-intl/dist/es/dates.js
// module chunks = 3